<template>
  <base-material-card
    color="indigo"
    icon="mdi-tag-multiple"
    inline
    class="px-5 py-3"
  >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        {{ title }}
      </div>
    </template>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
        />
      </v-col>
    </v-row>

    <v-divider class="mt-3" />

    <v-data-table
      :headers="localizationHeaders"
      :items="items"
      :search.sync="search"
      :sort-by="['name']"
      :sort-desc="[false]"
      :loading="loading"
    >
      <template v-slot:top>
        <v-row>
          <v-col
            md="8"
            sm="6"
          >
            <v-text-field
              v-model="productSubCategoryName"
              color="secondary"
              :label="$t('fields.productSubCategory.name')"
              outlined
            />
          </v-col>
          <v-col
            md="4"
            sm="4"
          >
            <v-btn
              elevation="1"
              color="primary"
              dark
              fab
              min-width="0"
              small
              @click="addproductSubCategory"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.name`]="props">
        <v-edit-dialog
          :return-value.sync="props.item.name"
          @save="editproductSubCategory(props.item)"
        >
          {{ props.item.name }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.name"
              :rules="[max50chars]"
              label="Edit"
              single-line
              counter
            />
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:[`item.image`]="{ item }">
        <input
          :ref="'file'+item.id"
          type="file"
          class="d-none"
          @change="selectImage($event, item)"
        >
        <v-card
          :class="item.imagePreview ? 'success--text' : 'grey--text'"
          class="mx-auto mt-2 mb-2 d-inline-flex v-card--account"
          outlined
          height="75"
          width="75"
          @click="$refs['file'+item.id].click()"
        >
          <v-img
            v-if="item.singleImage"
            :src="item.singleImage"
            height="100%"
            width="100%"
          />
          <v-icon
            v-else
            class="mx-auto"
            size="50"
          >
            mdi-image
          </v-icon>
        </v-card>
      </template>
      <template
        v-slot:[`item.actions`]="{ item }"
      >
        <v-btn
          color="error"
          class="px-1 ml-1"
          fab
          small
        >
          <v-icon @click="deleteProductCategory(item.id)">
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      v-model="showSuccessMessage"
      top
      :multi-line="true"
      color="success"
    >
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showErrorMessage = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="showErrorMessage"
      top
      :multi-line="true"
      color="error"
      :timeout="10000"
    >
      {{ errorMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showErrorMessage = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </base-material-card>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const productSubCategoriesRepository = repositoryFactory.get(
    'productSubCategories',
  )

  export default {
    name: 'ProductSubCategoryList',
    props: {
      productCategoryId: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      items: [],
      productSubCategoryName: '',
      search: undefined,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
      max50chars: v =>
        v.length <= 25 || 'El nombre no puede exceder 50 carácteres',
    }),
    computed: {
      title: {
        get () {
          return this.$t('productSubCategories')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.productSubCategory.name'),
            value: 'name',
          },
          {
            sortable: false,
            text: 'Imagen',
            value: 'image',
            align: 'center',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
            align: 'right',
          },
        ]
      },
    },
    mounted () {
      this.fecthData()
    },
    methods: {
      selectImage (val, item) {
        const value = val.target.files[0]
        if (!value) return (item.singleImage = null)
        item.singleImage = URL.createObjectURL(value)
        item.imageBytes = value
        this.$forceUpdate()
        this.editproductSubCategory(item)
      },
      fecthData () {
        var self = this
        self.loading = true
        productSubCategoriesRepository
          .getByCategory(self.productCategoryId)
          .then(response => {
            if (response.data.isValid) {
              self.items = response.data.data
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loading = false
          })
          .catch(err => {
            self.showErrorMessage = true
            if (err.response.status === 400) {
              self.errorMessage = err.response.data.errorMessages[0]
            } else {
              self.errorMessage = err
            }
            self.loading = false
          })
      },
      addproductSubCategory () {
        var self = this
        if (!self.productSubCategoryName) {
          return
        }
        console.log('id', self.productCategoryId)
        var data = new FormData()
        data.append(
          'data',
          JSON.stringify({
            name: self.productSubCategoryName,
            categoryId: self.productCategoryId,
          }),
        )
        // var data = {
        //   data: {
        //     name: self.productSubCategoryName,
        //     categoryId: self.productCategoryId,
        //   },
        // }
        self.loadingSave = true
        productSubCategoriesRepository
          .addproductSubCategory(data)
          .then(response => {
            if (response.data.isValid) {
              self.productSubCategoryName = ''
              self.fecthData()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          })
          .catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
      },
      editproductSubCategory (item) {
        var self = this
        var data = new FormData()
        data.append(
          'data',
          JSON.stringify({ id: item.id, name: item.name, categoryId: item.categoryId }),
        )
        if (item.imageBytes != null) {
          data.append('imageBytes', item.imageBytes, item.imageBytes.name)
        } else {
          data.append('imageBytes', null)
        }
        // var data = {
        //   data: { name: item.name, id: item.id, categoryId: item.categoryId },
        // }
        self.loadingSave = true
        productSubCategoriesRepository
          .updateproductSubCategory(data, item.id)
          .then(response => {
            if (response.data.isValid) {
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          })
          .catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
      },
      deleteProductCategory (id) {
        var self = this
        var r = confirm('¿Desea Eliminar esta sub-categoría?')
        if (r === true) {
          self.loading = true
          productSubCategoriesRepository.remove(id).then(response => {
            console.log(response)
            if (response.status === 204) {
              self.successMessage = 'sub categoría eliminada'
              self.showSuccessMessage = true
              this.fecthData()
            } else {
              self.errorMessage = 'Error, No se pudo eliminar la sub-categoría'
              self.showErrorMessage = true
            }
            self.loading = false
          }).catch(err => {
            self.errorMessage = 'No se puede eliminar, Algunos productos utilizan esta sub categoría ' + err
            self.showErrorMessage = true
            self.loading = false
          })
        }
      },
    },
  }
</script>
